var lastClick;
var accordionActions = document.querySelectorAll('[data-accordion-action]');
var accordionTargets = document.querySelectorAll('[data-accordion-target]');

var hideTargets = function () {
  for (var i = 0; i < accordionActions.length; i++) {
    var accordionAction = accordionActions[i];
    accordionAction.classList.remove('collapsed');
  }
  for (var i = 0; i < accordionTargets.length; i++) {
    var accordionTarget = accordionTargets[i];
    accordionTarget.style.maxHeight = null;
    accordionTarget.style.marginBottom = "0";
    accordionTarget.classList.remove('open');
    accordionTarget.classList.add('close');

  }
};

var showTarget = function (targetSelector) {
  var target = document.querySelector(targetSelector);
  if (target !== undefined) {
    target.style.maxHeight = target.scrollHeight + "px";
    target.style.marginBottom = "5px";
    target.classList.add('open');
    target.classList.remove('close');
  }
};

hideTargets();

for (var i = 0; i < accordionActions.length; i++) {
  var accordionAction = accordionActions[i];
  accordionAction.addEventListener('click', function (e) {
    e.preventDefault();
    hideTargets();
    if (lastClick !== e.currentTarget) {
      $(this).addClass('collapsed');
      showTarget(e.currentTarget.getAttribute('href'));
      lastClick = e.currentTarget;
    } else {
      $(this).removeClass('collapsed');
      lastClick = null;
    }
  });
}